import React from "react";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { Chip, CircularProgress } from "@material-ui/core";
import MenuCard from "../../components/menu-card";
import { descriptionTextSize, colors, tooltipTextSize } from "../../lib/constants";
import { toggleCheckedTag } from "../../epics/stepThreeEpics";
import { CheckCircleOutline, RadioButtonUnchecked } from "@material-ui/icons";

export default function StepThree() {
  const dispatch = useDispatch();

  const keyphrases = useSelector((state) => state.keyphrases); // von react-redux
  const checkedStepOne = useSelector((state) => state.checkedCardStepOne);
  const checkedCardTwo = useSelector((state) => state.checkedCardStepTwo);
  const checkedTags = useSelector((state) => state.checkedTags);
  const taxonomyGroups = useSelector((state) => state.taxonomyGroups); // in 1. card mit farben für tags (rausfiltern von taggroups auf rechter seite)
  const taxonomyColors = useSelector((state) => state.taxonomyGroupColors);

  // tags (erste card)
  const customRenderer = (tag, classes, sizeBreak) => {
    // react-tagcloud
    const fontSize = sizeBreak ? tooltipTextSize : descriptionTextSize;
    let index = -1;
    if (taxonomyColors.length === 0 || taxonomyGroups[checkedStepOne + " " + checkedCardTwo].length === 0)
      return <CircularProgress style={{ margin: "7px" }} />;

    let keys = Object.keys(taxonomyGroups[checkedStepOne + " " + checkedCardTwo]);
    for (let i = 0; i < keys.length; i++) {
      if (
        _.findIndex(taxonomyGroups[checkedStepOne + " " + checkedCardTwo][keys[i]], (el) => {
          return el.node === tag.value;
        }) !== -1
      ) {
        index = i;
        break;
      }
    }

    const style = {
      fontSize,
      backgroundColor: "transparent",
      border: index !== -1 ? `3px solid ${colors[keys[index]]}` : `3px solid ${colors.noGroup}`,
      margin: "7px",
      color: "#424242",
      width: "fit-content",
      padding: 0
    };

    // einzelner tag
    return (
      <Chip
        key={tag.value}
        label={tag.value}
        className={classes.customChip}
        style={style}
        deleteIcon={
          _.indexOf(checkedTags[checkedStepOne + " " + checkedCardTwo], tag.value) === -1 ? (
            <RadioButtonUnchecked style={{ pointerEvents: "none", width: sizeBreak ? 19 : 22, color: "#808080" }} />
          ) : (
            <CheckCircleOutline style={{ pointerEvents: "none", width: sizeBreak ? 19 : 22, color: "#808080" }} />
          )
        }
        onDelete={() => {}}
      />
    );
  };

  // keyphrases aus beiden texten
  const data = keyphrases[checkedStepOne + " " + checkedCardTwo];
  const tags = [];

  if (taxonomyGroups[checkedStepOne + " " + checkedCardTwo]) {
    Object.keys(data).forEach((key) => {
      tags.push({ value: key, count: 20 });
    });
  }

  const onClick = (e) => dispatch(toggleCheckedTag(checkedStepOne + " " + checkedCardTwo, e.value));

  const content = [tags, onClick, customRenderer];
  const focus = 3;

  return <MenuCard focus={focus} content={content} />;
}
